export { default } from './TableSortLabel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TableSortLabel/index.js
// module id = 720
// module chunks = 0